import * as React from 'react';
import * as _ from 'lodash';
import * as Styles from './styles';
import { KEYS } from 'common/constants';
// import { TEMPLATE_CAMPAIGN_TEXT } from 'common/texts';
import delayUnmounting from 'features/Dealers/DealerConfiguration/Modals/delayUnmounting';
// import { ActionBarOptions } from 'features/Templates/DuplicateTemplate/styles';
import ActionBar from 'components/ActionBar';

import {
    Container,
    Title,
    TitleContainer,
    Body,
    BodyText,
    ButtonContainer,
    Notice,
    SuccessText,
    ErrorText
} from 'features/Dealers/DealerConfiguration/Modals/styles';
import Modal from 'components/Modal';
import { ModalTitle } from 'common/styles';

export interface ModalDisconnectProps {
    onDisconnectConfirmed: () => void;
    onCancel: () => void;
    onOKClose: () => void;
    shouldShow: boolean;
    isSyncing: boolean;
    errormessage?: string;
    successmessage?: string;
}

export interface ModalSyncStates {
    synced?: boolean;
}

class ModalDisconnect extends React.Component<ModalDisconnectProps, ModalSyncStates> {

    constructor(props: ModalDisconnectProps) {
        super(props);
        this.state = {
            synced: false,
        };
        this.onCancelClick = this.onCancelClick.bind(this)
        this.onOKCloseClick = this.onOKCloseClick.bind(this)
        this.onDisconnectConfirmed = this.onDisconnectConfirmed.bind(this)
    }

    onDisconnectConfirmed() {
        this.props.onDisconnectConfirmed();
        this.setState({ synced: true });
    }

    onCancelClick() {
        this.props.onCancel();
    }

    onOKCloseClick() {
        this.props.onOKClose();
    }

    keyDownHandle = (e) => {
        if (e.key === KEYS.ESCAPE) {
            this.props.onCancel()
        }
    }

    render() {
        return (
            <Modal shouldShow={this.props.shouldShow}>
            <Container onKeyDown={this.keyDownHandle} shouldShow={this.props.shouldShow}>
                    <ModalTitle>Disconnect Dealer's Listings</ModalTitle>
                <Body>
                    <BodyText>
                        By disconnecting the dealer's listings, you will remove the association between this dealership and the GBP listings. Any unpublished changes will be lost.
                    </BodyText>                 
                    <BodyText>
                        Are you sure that you want to disconnect this dealer's location?                        
                    </BodyText>                 
                </Body>
                
                <ButtonContainer>
                    <ActionBar
                        mainActionLabel={"YES"}
                        mainActionLoading={this.props.isSyncing}
                        secondaryActionLabel={"NO"}
                        onMainActionClick={this.onDisconnectConfirmed}
                        onSecondaryActionClick={this.onCancelClick}
                    />
                </ButtonContainer>
            </Container>
        </Modal>





     
        );
    }
}

export default delayUnmounting<ModalDisconnectProps>(ModalDisconnect);